import { type ResponseConfig } from "@kubb/plugin-client/clients/axios"
import { UseMutationOptions } from "@tanstack/react-query"

import { queryClient } from "~/backend/queryClient"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useDeleteMappingElement,
} from "~/gen/api/hooks"
import { DeleteMappingElementRequestDto } from "~/gen/api/types"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteMappingElementMutation = (
  queryParams: { page: number },
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    { data: DeleteMappingElementRequestDto }
  >
) =>
  useDeleteMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findMappingByTypeQueryKey(variables.data.type, queryParams),
        })
        await queryClient.invalidateQueries({
          queryKey: findPendingMappingQueryKey(),
        })
        showSuccessNotification({
          title: "Deleted",
          message: `mapping has been deleted`,
        })
      },
    },
  })
